import { MultipleSelectField, RadioGroup } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, formValueSelector, isDirty, reset } from "redux-form"

const ViewingAccessTab = ({
  accessType,
  metaTags,
  selectedCalendar,
  handleSave,
  tabIsActive,
  resetForm,
  isDirty,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card className="mt-3">
        <CardHeader>
          <h4>SET ACCESS</h4>
        </CardHeader>
        <CardBody>
          {!selectedCalendar && (
            <Row className="mb-3">
              <Col xs="auto">
                <i className="bx bx-info-circle font-size-22 me-2" />
                <span style={{ verticalAlign: "super" }}>
                  You have to first create the calendar and then you will able
                  to set the access.
                </span>
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <label>Access:</label>
            </Col>
          </Row>
          <Row>
            <Col xs="auto" className="my-1">
              <Field
                name="accessType"
                type="radio"
                component={RadioGroup}
                label="Open (User can see ALL Events)"
                value="1"
                disabled={!selectedCalendar}
              />
            </Col>
          </Row>
          <Row>
            <Col xs="auto" className="my-1">
              <Field
                name="accessType"
                type="radio"
                component={RadioGroup}
                label="By Tags"
                value="2"
                disabled={!selectedCalendar}
              />
            </Col>
          </Row>
          {parseInt(accessType) === 2 && (
            <Row>
              <Col xs={4} className="mt-1">
                <Field
                  name="tags"
                  placeholder="Enter tag"
                  component={MultipleSelectField}
                  options={metaTags.map(tag => ({
                    label: tag.tag,
                    value: tag.id,
                  }))}
                  disabled={!selectedCalendar}
                />
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.EVENT_CALENDAR)

const mapStateToProps = state => ({
  accessType: selector(state, "access.accessType"),
  metaTags: state.Tags.metaTags,
  selectedCalendar: state.Events.selectedCalendar,
  isDirty: isDirty(FORM_NAMES.EVENT_CALENDAR)(state, ...["access"]),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.EVENT_CALENDAR)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewingAccessTab)
